import { Reducer } from 'redux';

import {
    ActionTypes,
    CheckoutsTermsLoadSuccessAction,
    CheckoutsTermsState,
    CheckoutsTermsModifySuccessAction,
    CheckoutsTermsUpdateSuccessAction
} from './types';

const defaultState: CheckoutsTermsState = {
    isLoading: false,
    isLoaded: false,
    isError: false,
    terms: "",
    isDefault: false,
};

const updateState = <T extends string>(
    state: CheckoutsTermsState,
    overrides: Partial<CheckoutsTermsState>,
    payload?: T,
    isDefault?: boolean
): CheckoutsTermsState => ({
    ...state,
    ...overrides,
    terms: payload ?? state.terms,
    isDefault: isDefault ?? state.isDefault,
})

const loadStart = (state: CheckoutsTermsState): CheckoutsTermsState =>
    updateState(state, { isLoading: true, isLoaded: false, isError: false });

const loadSuccess = (state: CheckoutsTermsState, action: CheckoutsTermsLoadSuccessAction): CheckoutsTermsState =>
    updateState(state, { isLoading: false, isLoaded: true, isError: false }, action.payload.terms, action.payload.isDefault);

const loadError = (state: CheckoutsTermsState): CheckoutsTermsState =>
    updateState(state, { isLoading: false, isLoaded: false, isError: true });

const updateStart = (state: CheckoutsTermsState): CheckoutsTermsState =>
    updateState(state, { isLoading: true, isLoaded: false, isError: false });

const updateSuccess = (state: CheckoutsTermsState, action: CheckoutsTermsUpdateSuccessAction): CheckoutsTermsState =>
    updateState(state, { isLoading: false, isLoaded: true, isError: false }, action.payload.terms, action.payload.isDefault);

const updateError = (state: CheckoutsTermsState): CheckoutsTermsState =>
    updateState(state, { isLoading: false, isLoaded: false, isError: true });

const modifySuccess = (state: CheckoutsTermsState, action: CheckoutsTermsModifySuccessAction): CheckoutsTermsState =>
    updateState(state, { isLoading: false, isLoaded: true, isError: false }, action.payload.terms, action.payload.isDefault);

const modifyError = (state: CheckoutsTermsState): CheckoutsTermsState =>
    updateState(state, { isLoading: false, isLoaded: false, isError: true });


const reducer: Reducer<CheckoutsTermsState> = (
    state: CheckoutsTermsState = defaultState,
    action
): CheckoutsTermsState => {
    switch (action.type) {
        case ActionTypes.LOAD_START:
            return loadStart(state);
        case ActionTypes.LOAD_SUCCESS:
            return loadSuccess(state, action as CheckoutsTermsLoadSuccessAction);
        case ActionTypes.LOAD_ERROR:
            return loadError(state);
        case ActionTypes.UPDATE_START:
            return updateStart(state);
        case ActionTypes.UPDATE_SUCCESS:
            return updateSuccess(state, action as CheckoutsTermsUpdateSuccessAction);
        case ActionTypes.UPDATE_ERROR:
            return updateError(state);
        case ActionTypes.MODIFY_SUCCESS:
            return modifySuccess(state, action as CheckoutsTermsModifySuccessAction);
        case ActionTypes.MODIFY_ERROR:
            return modifyError(state);
        default:
            return state;
    }
};

export { reducer as checkoutsTerms };

export default reducer;